// extracted by mini-css-extract-plugin
export default {"boost":"Boost_boost__VPt-+"};